import { Search } from 'lucide-react';
import { useTenants } from '../../../../components/tenant-selector/useTenants';
import { ActiveFilterChips } from '../../automations-tab/templates-manager/templates-toolbar/ActiveFilterChips';
import {
  StatusFilterMenu,
  type StatusFilterOption,
} from '../../automations-tab/templates-manager/templates-toolbar/StatusFilterMenu';
import { TenantFilterMenu } from '../../automations-tab/templates-manager/templates-toolbar/TenantFilterMenu';
import toolbarStyles from '../../automations-tab/templates-manager/templates-toolbar/templates-toolbar.module.css';
import { StatusFilter } from '../../automations-tab/templates-manager/types';
import type { SegmentListView } from './types';

// Segments have no "Available" tier.
const SEGMENT_STATUS_OPTIONS: StatusFilterOption[] = [
  { value: StatusFilter.All, label: 'All statuses' },
  { value: StatusFilter.Active, label: 'Active' },
  { value: StatusFilter.Draft, label: 'Draft' },
];

export function SegmentsToolbar({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  statusCounts,
  selectedTenantIds,
  toggleTenant,
  clearTenants,
  tenantFilterOptions,
  hasActiveFilters,
  clearAllFilters,
  filteredCount,
  totalCount,
}: SegmentListView) {
  const { data: tenants, isLoading: isTenantsLoading } = useTenants();
  const tenantNameById = new Map((tenants ?? []).map(tenant => [tenant.id, tenant.name]));

  const resultLabel = `${filteredCount} of ${totalCount} segments`;

  return (
    <div>
      <div className={toolbarStyles.toolbar}>
        <div className={toolbarStyles.search}>
          <Search className={toolbarStyles.searchIcon} />
          <input
            type="text"
            className={toolbarStyles.searchInput}
            placeholder="Search segments by name…"
            value={search}
            onChange={event => setSearch(event.target.value)}
          />
        </div>

        <StatusFilterMenu
          value={statusFilter}
          counts={statusCounts}
          onChange={setStatusFilter}
          options={SEGMENT_STATUS_OPTIONS}
        />

        <TenantFilterMenu
          tenantOptions={tenantFilterOptions}
          selectedTenantIds={selectedTenantIds}
          toggleTenant={toggleTenant}
          clearTenants={clearTenants}
          isLoading={isTenantsLoading}
        />

        <span className={toolbarStyles.resultCount}>{resultLabel}</span>
      </div>

      {hasActiveFilters && (
        <ActiveFilterChips
          statusFilter={statusFilter}
          clearStatus={() => setStatusFilter(StatusFilter.All)}
          selectedTenantIds={selectedTenantIds}
          tenantNameById={tenantNameById}
          removeTenant={toggleTenant}
          clearAll={clearAllFilters}
        />
      )}
    </div>
  );
}
